import App from "@/views/App.vue";

export default [
  {
    path: "/notificacao",
    name: "notification",
    component: App,
    redirect: { name: "notificationHome" },
    children: [
      {
        path: "",
        name: "notificationHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Notification.vue"),
        meta: {
          displayName: "displayName.notification",
          requiresAuth: true,
        },
      },
    ],
  },
];
